import { useContext } from "react";
import "./CharacterDetails.css";
import { MainContext } from "../App";
import { WorldHandler as WH } from "../controllers/world";
import { statusIcons } from "./World";
import { Card, Avatar } from "antd";
import {} from "@ant-design/icons";
import {
  CharacterHandler as CH,
  CharacterState,
  StatusType,
} from "../controllers/characters";

const CharacterDetails = () => {
  const { appState: context /*, setAppState: setContext*/ } =
    useContext(MainContext);
  let char = null;

  const renderCharacter = (char: CharacterState) => {
    const age = Math.round(CH.age(char) / 12); //age in years (currently)
    const ageTag = CH.ageTag(char).toLowerCase();
    const { world: w } = context;

    let father = null;
    let mother = null;

    if (char.parents) {
      father = WH.getCharacter(w, char.parents.father);
      mother = WH.getCharacter(w, char.parents.mother);
    }

    //get Children
    //@TODO: expensive computation ?
    const children: CharacterState[] = w.characters.filter(
      (c) =>
        c.parents &&
        (c.parents.father === char.id || c.parents.mother === char.id)
    );

    return (
      <Card
        className={`char-details-${ageTag}`}
        key={`char-details-${char.id}`}
      >
        <Card.Meta
          avatar={
            <Avatar src={`./avatars/cartoonset10k/${char.avatar}`} size={64} />
          }
          title={CH.fullname(char)}
        />
        <div className="char-row-status">
          {char.statusList
            .filter((s) => s.type !== StatusType.ALIVE)
            .map((s) => statusIcons[s.type])}
        </div>
        <div className="char-row-genes">
          Traits: {char.genes.map((s) => s.trait.toLocaleLowerCase()).join(",")}
        </div>
        <div className="char-row-age">Age: {age}</div>
        <div className="char-row-hp">
          HP: {`${CH.hp(char)}/${CH.hpMax(char)}`}
        </div>
        <div className="char-row-hp">Pos: {`${char.pos.x}x${char.pos.y}`}</div>
        <div className="char-row-parents">
          Father:{" "}
          {father ? `${father.firstname} ${father.lastname}` : "unknown"}{" "}
        </div>
        <div className="char-row-parents">
          Mother:{" "}
          {mother ? `${mother.firstname} ${mother.lastname}` : "unknown"}{" "}
        </div>
        <div className="char-row-hp">Id: {`${char.id}`}</div>
        <div>
          <div>Children:</div>
          <div>{children.map(CH.fullname).join(", ")}</div>
        </div>
        <div>
          <div>Factions:</div>
          <div>
            {char.factions.map((f) => (
              <div
                key={`factions-${char.id}-${f.factionId}`}
              >{`${f.factionName} influence: ${f.influence}`}</div>
            ))}
          </div>
          <div>Possessions:</div>
          <div>
            {char.possessions.map((p) => (
              <div
                key={`possession-${char.id}-${p.type}`}
              >{`${p.type}: ${p.quantity}`}</div>
            ))}
          </div>
        </div>
      </Card>
    );
  };

  if (context.view.characterHighlighted) {
    char = context.world.characters.find(
      (c) => c.id === context.view.characterHighlighted
    );
    //char = context.world.deads.find(c => c.id === context.view.characterHighlighted);
  }

  return (
    <div className="character-details">
      {context.view.characterHighlighted && char ? (
        renderCharacter(char)
      ) : (
        <div>NO CHARACTER HIGHLIGHTED</div>
      )}
    </div>
  );
};

export default CharacterDetails;
